export const ActionTypes = {
    SET_USERS: "app/redux/mgt-user/SET_USERS",
    ADD_USER: "app/redux/mgt-user/ADD_USER",
    UPDATE_USER: "app/redux/mgt-user/UPDATE_USER",
    UPDATE_USER_IS_APPROVE: "app/redux/mgt-user/UPDATE_USER_IS_APPROVE",
    DELETE_USER: "app/redux/mgt-user/DELETE_USER",
}